const parallax = () => {
  const imageContainer = document.querySelector('#parallaxContainer');

  if (!imageContainer) {
    return;
  }

  window.addEventListener('resize', function () {
    const requestAnimationFrame = window.requestAnimationFrame ||
    window.mozRequestAnimationFrame ||
    window.webkitRequestAnimationFrame ||
    window.msRequestAnimationFrame;

    const transforms = ['transform',
      'msTransform',
      'webkitTransform',
      'mozTransform',
      'oTransform'];

    const transformProperty = getSupportedPropertyName(transforms);

    let scrolling = false;
    let mouseWheelActive = false;

    let count = 0;
    let mouseDelta = 0;


    function getSupportedPropertyName(properties) {
      for (let i = 0; i < properties.length; i++) {
        if (typeof document.body.style[properties[i]] !== 'undefined') {
          return properties[i];
        }
      }
      return null;
    }

    function setup() {
      window.addEventListener('scroll', setScrolling);

      window.addEventListener('mousewheel', mouseScroll, {passive: false});
      window.addEventListener('DOMMouseScroll', mouseScroll, {passive: false});

      animationLoop();
    }
    setup();

    function mouseScroll(e) {
      mouseWheelActive = true;

      if (e.preventDefault) {
        e.preventDefault();
      }

      if (e.wheelDelta) {
        mouseDelta = e.wheelDelta / 320;
      } else if (e.detail) {
        mouseDelta = -e.detail / 3;
      }
    }

    function setScrolling() {
      scrolling = true;
    }

    function getScrollPosition() {
      if (document.documentElement.scrollTop === 0) {
        return document.body.scrollTop;
      } else {
        return document.documentElement.scrollTop;
      }
    }

    function setTranslate3DTransform(element, yPosition) {
      let value = 'translate3d(0px' + ', ' + yPosition + 'px' + ', 0)';
      element.style[transformProperty] = value;
    }

    function animationLoop() {
      if (scrolling) {
        setTranslate3DTransform(imageContainer,
            -1 * getScrollPosition() / 100);
        scrolling = false;
      }

      if (mouseWheelActive) {
        window.scrollBy(0, -mouseDelta * 20);
        count++;

        if (count > 20) {
          count = 0;
          mouseWheelActive = false;
          mouseDelta = 0;
        }
      }
      requestAnimationFrame(animationLoop);
    }
  });
};

export {parallax};
